import Layout from "layout/Layout";
import Header from "./Header";
import InstallPWAButton from "components/PWA Button";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Landing() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      const hasHash = window.location.hash;

      if (token && location.pathname === "/" && !hasHash) {
        navigate("/dashboard");
      }
    }, 50);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Layout>
        <Header />
        {/* <ContactUs /> */}
      </Layout>

      <InstallPWAButton />
    </>
  );
}

export default Landing;
